import { rootApi } from '../api/rootApi';
import { getApi } from '../api/getApi';
import { postApi } from '../api/postApi';
import { putApi } from '../api/putApi';
import { deleteApi } from '../api/deleteApi';

// extend rootApi dynamically to avoid hardcoding everywhere if we miss something
const serviceRequestsUrl = `${rootApi.tours.replace('/tours', '')}/serviceRequests`;

export const serviceRequestService = {
    getAllRequests: async () => {
        return await getApi(serviceRequestsUrl);
    },
    getMyRequests: async (email) => {
        return await getApi(`${serviceRequestsUrl}/${email}`);
    },
    addRequest: async (data) => {
        return await postApi(serviceRequestsUrl, data);
    },
    updateRequestStatus: async (id) => {
        return await putApi(`${serviceRequestsUrl}/${id}`, {});
    },
    deleteRequest: async (id) => {
        return await deleteApi(`${serviceRequestsUrl}/${id}`);
    }
};
